import { Input } from 'antd'
import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import PermissionEditor from '../../../../../../PermissionEditor'

export const EditRoleModalBody: React.FC = () => {
  return (
    <>
      <CIMSFormItem
        name={'name'}
        label={'Name'}
        help={HelpMessage.Administration.Roles.Name}
        requiredMessage="Please enter a name"
      >
        <Input />
      </CIMSFormItem>
      <CIMSFormItem name={'permissionIds'}>
        <PermissionEditor help={HelpMessage.Administration.Roles.Permissions} />
      </CIMSFormItem>
    </>
  )
}

export interface EditRoleModalValues {
  name: string
  permissionIds: string[]
}
